import { useEffect, useRef, useState } from "react";
import { useLocation, matchPath } from "react-router-dom";
import ProductList from "./ProductList";
import ProductSinglePage from "./ProductSingle";
import { Modal } from "./common/Modal";

const ProductListWrapper = () => {
  const location = useLocation();
  const match = matchPath("/product/:productId", location.pathname);
  const productId = match?.params?.productId;
  const [fromProduct, setFromProduct] = useState(false);
  useEffect(() => {
    const scrollPos = sessionStorage.getItem("scrollPosition");

    if (scrollPos) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(scrollPos, 10));

        sessionStorage.removeItem("scrollPosition");
      }, 0);
    }

    // // Мы были на странице товара, и перешли обратно на список
    // if (prevProductId && !productId) {
    //     const scrollPos = sessionStorage.getItem('scrollPosition');
    //     if (scrollPos) {
    //         setTimeout(() => {
    //             window.scrollTo(0, parseInt(scrollPos, 10));
    //             sessionStorage.removeItem('scrollPosition');
    //         }, 0);
    //     }
    // }
    //
    // prevProductIdRef.current = productId;
    if (productId) {
      setFromProduct(true);
      document.querySelector('html').style.overflow='hidden'
    } else {
      setFromProduct(false);
      
    }
    return ()=>{
      document.querySelector('html').style.overflow='visible'
    }
  }, [productId, location]);

  return (
    <>
    <ProductList fromProduct={fromProduct} />
        <Modal
          isOpen={productId}
          contentStyle={{
            maxWidth: "100%",
            width: "100%",
            height: "100%",
            overflow: "auto",
            padding: '0'
          }}
        >
          <ProductSinglePage />
        </Modal>
    </>
  );
};

export default ProductListWrapper;
